<form [formGroup]="activationMethodFormGroup"  id="step-activation-method" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    <div class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="activation-method-title"  class="pb-2">{{ 'WARRANTY_ACTIVATION.ACTIVATION_METHOD' | translate }}</h2>
        <label data-testid="activation-method-label" class="block text-sm">{{ 'WARRANTY_ACTIVATION.SELECT_ACTIVATION_METHOD' | translate }}:</label>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6">
        <div class="row">
          <div class="col-12">
            <label data-testid="activation-method-serial-label" class="inline-flex mr-6">
              <p-radioButton data-testid="activation-method-serial" name="activationMethod" [value]="warrantyActivationMethod.SERIAL_NUMBER" formControlName="activationMethod" inputId="serial" />
              <span for="serial" class="ml-2">{{ 'WARRANTY_ACTIVATION.BY_SERIAL_NUMBER' | translate }}</span>
            </label>
            <label class="inline-flex mr-2">
              <p-radioButton data-testid="activation-method-reference-label" name="activationMethod" [value]="warrantyActivationMethod.REFERENCE_NUMBER" formControlName="activationMethod" inputId="reference" />
              <span data-testid="activation-method-reference" for="reference" class="ml-2">{{ 'WARRANTY_ACTIVATION.BY_REFERENCE_NUMBER' | translate }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="field-wr flex flex-col col-12 mt-2">
        <div class="row">
          <div class="field-wr flex flex-col col-12 col-md-2">
              <button data-testid="activation-method-btn"class="btn primary-btn" [disabled]="activationMethodFormGroup.invalid" (click)="onSaveStepData()">{{ 'WARRANTY_ACTIVATION.BTN_NEXT_STEP' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
